<template>
  <div>
    <page-title-component title="Competition history" subtitle />
    <section class="section">
      <div class="container">
        <loading-component v-if="isLoading" />
        <div v-else>
          <competitionsList :competitions="previousCompetitions"></competitionsList>
        </div>
      </div>
    </section>
  </div>
</template>

<script>
import apiService from "./../services/apiService";
import competitionsList from "../components/CompetitionsList.vue";
import LoadingComponent from "./Loading.vue";
import PageTitleComponent from "./PageTitle.vue";

var moment = require("moment");
moment().format();

export default {
  name: "PreviousCompetitionsMain",

  props: {
    msg: String
  },
  components: {
    competitionsList,
    LoadingComponent,
    PageTitleComponent
  },
  data() {
    return {
      isLoading: false,
      competitions: null
    };
  },
  created() {
    this.fetch();
  },
  methods: {
    async fetch() {
      this.isLoading = true;
      try {
        const competitionData = await apiService.getAllCompetitions();
        this.competitions = competitionData.data;
      } finally {
        this.isLoading = false;
      }
    }
  },
  computed: {
    previousCompetitions() {
      return this.competitions.slice(0, 10).filter(c => !c.isCurrent);
    }
  }
};
</script>

<style scoped>
h3 {
  margin: 40px 0 0;
}
ul {
  list-style-type: none;
  padding: 0;
}
li {
  display: inline-block;
  margin: 0 10px;
}
a {
  color: #42b983;
}
</style>
